import React, { useRef } from "react";
import { BackTop, Badge, Table } from "antd";
import { FC, useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { PatientSchemeListProps } from "../../props/PatientDetailsProps";
import { useUserFunctionalities } from "../../utils/UserFunctionalities";

const PatientSchemeList: FC<PatientSchemeListProps> = ({
  data,
  isFetchingAllPatientSchemeList,
  handleEditClick,
  scrollToTarget,
}) => {
  const { hasFunctionality, reloadFunctionalities } = useUserFunctionalities();
  useEffect(() => {
    // Optionally reload functionalities when component mounts
    reloadFunctionalities();
  }, [reloadFunctionalities]);
  const columns = [
    {
      title: "S. No.",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "SELECTED SCHEMES",
      dataIndex: "selectedScheme",
      key: "selectedScheme",
    },
    {
      title: "SCHEME POLICY NUMBER",
      dataIndex: "schemePolicyNumber",
      key: "schemePolicyNumber",
    },
    {
      title: "SCHEME STATUS",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <Badge
          className="site-badge-count-109"
          count={status}
          style={{
            backgroundColor:
              status === "INACTIVE" ? "rgb(200 102 101)" : "#52c41a",
          }}
        />
      ),
    },
  ].concat(
    hasFunctionality("schemeEdit")
      ? [
          {
            title: "ACTION",
            dataIndex: "action",
            key: "action",
          },
        ]
      : []
  );

  const datas = data?.map((scheme, idx) => ({
    id: idx + 1,
    selectedScheme: scheme?.schemeName,
    schemePolicyNumber: scheme?.schemePolicyNumber,
    status: scheme?.status,
    action: (
      <EditOutlined
        onClick={() => {
          handleEditClick(idx, scheme);
          if (scrollToTarget) {
            scrollToTarget();
          }
        }}
      />
    ),
  }));

  return (
    <div>
      <Table
        columns={columns}
        dataSource={datas}
        loading={isFetchingAllPatientSchemeList}
      />
    </div>
  );
};

export default PatientSchemeList;
